import React from 'react'
import Breadcrumbs from '.'

const DefaultBreadcrumbsPharma = ({
  geo_parent,
  geo_id,
  geo_type,
  dashboardType,
}) => {
  debugger
  return (
    <Breadcrumbs>
      {geo_type.toUpperCase() === 'NAT' && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/Home'}
          />
          <Breadcrumbs.Item className={'label'} key={'US'} label={'US'} last />
        </>
      )}
      {geo_type.toUpperCase() === 'STATE' && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/Home'}
            first
          />
          <Breadcrumbs.Item
            key="US"
            label="US"
            href={'/forecasts/' + dashboardType.toLowerCase() + 'dashboard'}
          />
          <Breadcrumbs.Item
            className={'label'}
            key={geo_id}
            label={geo_id.toUpperCase()}
            last
          />
        </>
      )}
      {(geo_type.toUpperCase() === 'MSA' || geo_type.toUpperCase() === 'COUNTY' || geo_type.toUpperCase()  === 'ZIP3') && (
        <>
          <Breadcrumbs.Item
            key="My Dashboard"
            label="My Dashboard"
            href={'/Home'}
            first
          />
          <Breadcrumbs.Item
            key="US"
            label="US"
            href={'/forecasts/' + dashboardType.toLowerCase() + 'dashboard'}
          />
          {geo_type.toUpperCase() !== 'ZIP3' && (
            <Breadcrumbs.Item
              key={geo_parent}
              last={geo_type === 'ZIP3'}
              href={'/forecasts/' + dashboardType.toLowerCase() + 'statedashboard/state/' + geo_parent.toLowerCase()}
              label={`${geo_parent}`}
            />
          )}
           {geo_type === 'ZIP3' && geo_id !== undefined  && (            
                      <Breadcrumbs.Item
                        key={geo_parent}
                        last={true}
                        href={
                          '/' + dashboardType.toLowerCase() + 'statedashboard/state/' + geo_parent.toLowerCase()
                        }
                        label={`${geo_parent}, ${geo_id}`}
                      />
            )}

     
        </>
      )}
    </Breadcrumbs>
  )
}

export default DefaultBreadcrumbsPharma
